import React from 'react';
import { getActiveIcon } from 'library/helpers';
import { RouteLegs } from 'views/travel/RouteLegs';
import { DocLink, DocPages } from 'components/Help';
import { THEME_NAMES } from 'selectors/tag.selectors';
import { AuditHistory } from 'components/Audit';
import { CanViewTravel } from 'library/permissions';
import RouteFormInput from './input';

const config = {
  init: {
    active: true
  },
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Type',
        dataIndex: 'route_type__name',
        width: '130px',
        sorter: true,
        render: (text, record) => record.type
      },
      {
        title: 'Mode',
        dataIndex: 'travel_mode',
        width: '100px',
        sorter: true,
        render: (text, record) => record.travel_mode
      },
      {
        title: 'Depart',
        dataIndex: 'departure_location__name',
        width: '200px',
        sorter: true,
        render: (text, record) => `${record.departure_location.name} (${record.departure_location.code})`
      },
      {
        title: 'Arrive',
        dataIndex: 'arrival_location__name',
        width: '200px',
        sorter: true,
        render: (text, record) => `${record.arrival_location.name} (${record.arrival_location.code})`
      },
      {
        title: 'Active',
        dataIndex: 'active',
        width: '110px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [{
          text: 'Active',
          value: true
        }, {
          text: 'Inactive',
          value: false
        }],
        render: (text, record) => getActiveIcon(record.active)
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the route
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      },
      route_type__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['route_type__name'],
        searchValue: ''
      },
      travel_mode: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['travel_mode'],
        searchValue: ''
      },
      departure_location__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['departure_location__name'],
        searchValue: ''
      },
      arrival_location__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['arrival_location__name'],
        searchValue: ''
      }
    },
    // General
    title: <DocLink page={DocPages.travelRoutes}>Routes</DocLink>
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Route',
    title: 'Route',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <RouteFormInput
            {...props}
            title="Route"
          />
        )
      },
      {
        key: 1,
        title: 'Legs',
        component: props => (
          <RouteLegs
            {...props}
          />
        )
      },
      {
        key: 2,
        title: 'History',
        component: props => (
          <AuditHistory
            {...props}
            themeName={THEME_NAMES.route}
          />
        ),
        show: () => CanViewTravel()
          .hasPermissions()
      }

    ]
  }
};

export default config;
